import React, { type ReactElement } from 'react';

interface IconGooglePlayProps {
  width?: number;
  height?: number;
  className?: string;
}

export function IconGooglePlay({
  width = 17,
  height = 17,
  className,
}: IconGooglePlayProps): ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      height={height}
      viewBox="0 0 17 17"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.822305 1.00501C0.596107 1.24868 0.481718 1.56053 0.502382 1.87719V15.6336C0.482887 15.9501 0.597138 16.2616 0.822305 16.5058L0.874656 16.5528L9.45441 8.84417V8.66138L0.874656 0.958008L0.822305 1.00501Z"
        fill="url(#paint0_linear_3439_24024)"
      />
      <path
        d="M12.315 11.4093L9.45312 8.83974V8.65695L12.315 6.09265L12.3789 6.12399L15.7701 7.85267C16.7415 8.34359 16.7415 9.15309 15.7701 9.64924L12.3789 11.3779L12.315 11.4093Z"
        fill="url(#paint1_linear_3439_24024)"
      />
      <path
        d="M12.3782 11.3781L9.46985 8.76678L0.820312 16.5015C1.01968 16.6487 1.2679 16.7321 1.5259 16.7388C1.78389 16.7454 2.03702 16.6748 2.24542 16.5381L12.3608 11.3781"
        fill="url(#paint2_linear_3439_24024)"
      />
      <path
        d="M12.3782 6.12404L2.24542 0.958869C2.03925 0.816553 1.78445 0.742917 1.52453 0.750537C1.26461 0.758157 1.0157 0.846561 0.820312 1.00065L9.4524 8.75102L12.3782 6.12404Z"
        fill="url(#paint3_linear_3439_24024)"
      />
      <path
        d="M12.3156 11.3204L2.24676 16.4491C2.04591 16.5834 1.80213 16.656 1.55165 16.656C1.30118 16.656 1.0574 16.5834 0.85655 16.4491L0.804199 16.4961L0.85655 16.5431C1.0574 16.6774 1.30118 16.75 1.55165 16.75C1.80213 16.75 2.04591 16.6774 2.24676 16.5431L12.3621 11.3831L12.3156 11.3204Z"
        fill="black"
        opacity="0.1"
      />
      <path
        d="M0.821613 16.4177C0.596604 16.1717 0.48267 15.8584 0.502447 15.5403V15.6291C0.482999 15.9456 0.59698 16.2571 0.821613 16.5013L0.87384 16.4543L0.821613 16.4177Z"
        fill="black"
        opacity="0.07"
      />
      <path
        d="M15.7716 9.55522L12.3164 11.3205L12.3804 11.3779L15.7716 9.62834C15.9705 9.5498 16.1426 9.42526 16.2703 9.26743C16.3981 9.10961 16.4769 8.92416 16.4987 8.73004C16.459 8.90948 16.3723 9.07788 16.2459 9.22135C16.1195 9.36482 15.9569 9.47926 15.7716 9.55522Z"
        fill="black"
        opacity="0.07"
      />
      <path
        d="M2.24796 1.05335L15.7719 7.94199C15.9555 8.01608 16.117 8.128 16.2433 8.26866C16.3697 8.40931 16.4573 8.57474 16.499 8.7515C16.4784 8.55705 16.4001 8.37113 16.2722 8.21313C16.1443 8.05513 15.9716 7.93083 15.7719 7.85321L2.24796 0.959341C1.29401 0.468415 0.50293 0.875779 0.50293 1.8733V1.96209C0.50293 0.969786 1.29401 0.557199 2.24796 1.05335Z"
        fill="white"
        opacity="0.3"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint0_linear_3439_24024"
          x1="8.69823"
          x2="-1.68149"
          y1="1.73096"
          y2="13.2915"
        >
          <stop stopColor="#008EFF" />
          <stop offset="0.01" stopColor="#008FFF" />
          <stop offset="0.26" stopColor="#00ACFF" />
          <stop offset="0.51" stopColor="#00C0FF" />
          <stop offset="0.76" stopColor="#00CDFF" />
          <stop offset="1" stopColor="#00D1FF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint1_linear_3439_24024"
          x1="15.8864"
          x2="-0.877414"
          y1="8.75095"
          y2="8.75095"
        >
          <stop stopColor="#FFD800" />
          <stop offset="1" stopColor="#FF8A00" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint2_linear_3439_24024"
          x1="10.7903"
          x2="-3.28132"
          y1="10.1769"
          y2="25.8493"
        >
          <stop stopColor="#FF3A44" />
          <stop offset="1" stopColor="#B11162" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="paint3_linear_3439_24024"
          x1="-1.35516"
          x2="4.93346"
          y1="-3.57959"
          y2="3.41867"
        >
          <stop stopColor="#328E71" />
          <stop offset="0.07" stopColor="#2D9571" />
          <stop offset="0.48" stopColor="#15BD74" />
          <stop offset="0.8" stopColor="#06D575" />
          <stop offset="1" stopColor="#00DE76" />
        </linearGradient>
      </defs>
    </svg>
  );
}
